export default __webpack_public_path__ + "static/media/wallpaper_03.4067e8e4.jpg";